@if (visible) {
<div class="sn-env-bar" [class.sn-env-bar--impersonating]="!!impersonatedName()" role="status">
  @if (label) {
  <span class="sn-env-bar__label">{{ label }}</span>
  }
  @if (label && showDetailsLink()) {
  <a
    class="sn-env-bar__link"
    [routerLink]="detailsRoute">
    Click Here for More Info
  </a>
  }
  @if (label && impersonatedName()) {
  <span class="sn-env-bar__separator" aria-hidden="true">|</span>
  }
  @if (impersonatedName()) {
  <span class="sn-env-bar__label">
    You are masquerading as {{ impersonatedName() }}
  </span>
  }
  @if (impersonatedName()) {
  <button
    type="button"
    class="sn-env-bar__action"
    (click)="onRevert()">
    Revert to your user
  </button>
  }
</div>
}
